import {
  Brain,
  Megaphone,
  ClipboardCheck,
  Database,
  FileText,
  Hammer,
  Headphones,
  Heart,
  Mail,
  Map,
  MessageSquare,
  Mic,
  Play,
  Server,
  Share2,
} from "lucide-react";

export const SERVICE_META = {
  rag: {
    label: "RAG Knowledge Base",
    icon: Database,
    color: "blue",
    desc: "AI-powered Q&A from your documents",
  },
  slm: {
    label: "Custom AI Model",
    icon: Brain,
    color: "purple",
    desc: "Fine-tuned model trained on your data",
  },
  private_llm: {
    label: "Private Hosted LLM",
    icon: Server,
    color: "amber",
    desc: "Dedicated language model for your organization",
  },
  datamap: {
    label: "Data Maps",
    icon: Map,
    color: "emerald",
    desc: "Automated data delivery and indicator tracking",
  },
  podcast: {
    label: "AI Podcast",
    icon: Mic,
    color: "rose",
    desc: "AI-generated podcast episodes from your content",
  },
  pas: {
    label: "Prior Authorization Support",
    icon: ClipboardCheck,
    color: "teal",
    desc: "AI-powered payer criteria lookup and PA guidance",
  },
  patient_aftercare: {
    label: "Patient Aftercare",
    icon: Heart,
    color: "violet",
    desc: "Discharge instructions, care protocols, and follow-up guidance",
  },
  telegram_bot: {
    label: "Telegram Bot",
    icon: MessageSquare,
    color: "cyan",
    desc: "AI-powered Telegram group moderation and messaging",
  },
  voip: {
    label: "VoiceIQ",
    icon: Headphones,
    color: "indigo",
    desc: "AI call center — live transcripts, call history, and voice agent",
  },
  article: {
    label: "Article Generator",
    icon: FileText,
    color: "green",
    desc: "AI-drafted civics articles grounded in your knowledge base",
  },
  marketing: {
    label: "Marketing Director",
    icon: Megaphone,
    color: "red",
    desc: "Prospect discovery, campaign strategy, and human-approved outreach",
  },
  email_intelligence: {
    label: "Email Intelligence",
    icon: Mail,
    color: "orange",
    desc: "AI-drafted email replies grounded in your knowledge base",
  },
  video: {
    label: "Video Studio",
    icon: Play,
    color: "fuchsia",
    desc: "AI-generated short videos from your content",
  },
  distribution: {
    label: "Distribution",
    icon: Share2,
    color: "sky",
    desc: "Publish your content to social platforms and track engagement",
  },
  construction: {
    label: "BuildIQ",
    icon: Hammer,
    color: "amber",
    desc: "Construction suite — manage settings here, build in the BuildIQ workspace",
  },
};

// ═══════════════════════════════════════════════════════════════════
// LOGIN PAGE
// ═══════════════════════════════════════════════════════════════════
